export const enum MintagaReviewCssSelectorEnum {
  mintagaview = '[data-qs="mintaga-building-reviews"]',
}
